import { createSelector } from 'reselect'
import { orderBy } from 'lodash'

const selectClientContacts = (state) => state.modals.RamsRecord.clientContacts

export default createSelector(
  selectClientContacts,
  (clientContacts) => orderBy(clientContacts, 'full_name')
)
